export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/product_descriptions.381ec78.svg";